module.exports = __webpack_public_path__ + "img/s3.518bbcff.jpg";